import { Asterisk } from "lucide-react";

export default function Marquee({ items }) {
    const half = (
        <div className="marquee-half">
            {items.map((t, i) => (
                <span key={i} className="flex items-center gap-14">
                    <span className="whitespace-nowrap font-display text-sm md:text-base uppercase tracking-[0.35em] text-mute">
                        {t}
                    </span>
                    <Asterisk className="h-5 w-5 shrink-0 text-gold" />
                </span>
            ))}
        </div>
    );
    return (
        <div data-testid="marquee" className="group relative overflow-hidden border-y border-white/10 bg-coal/40 py-5">
            <div className="marquee-track group-hover:[animation-play-state:paused]">
                {half}
                <div aria-hidden="true">{half}</div>
            </div>
        </div>
    );
}
